import React, { useRef, useState, useEffect } from "react";
import html2canvas from "html2canvas";
import { Row, Col, Button, Table } from "react-bootstrap";
import { db, storage } from "../FireBase"; // Import Firebase and Storage
import { ref, uploadString, getDownloadURL } from "firebase/storage";
import { doc, getDocs, where, query, collection, updateDoc, getDoc } from "firebase/firestore";
import "../css/GenerateReceipt.css";

const GenerateReceipt = ({ transaction }) => {
  console.log("Generating receipt for transaction:", transaction);
  const receiptRef = useRef(null);
  const [userName, setUserName] = useState(""); // Store user name
  const [storeDetails, setStoreDetails] = useState(null); // Store address and contact details
  const [downloadURL, setDownloadURL] = useState(null);
  const [isUploaded, setIsUploaded] = useState(false); // ✅ Prevent multiple uploads
  const [imgData, setImgData] = useState(null); // Store image data URL
  const [previewMode, setPreviewMode] = useState(false); // Preview mode toggle


  const ensureResourcesLoaded = async () => {
  // 1) Wait for web fonts (if supported)
  if (document.fonts && document.fonts.ready) {
    await document.fonts.ready;
  }

  // 2) Wait for all <img> in the receipt to load
  const imgs = receiptRef.current.querySelectorAll('img');
  await Promise.all(
    Array.from(imgs).map((img) => {
      if (img.complete) return Promise.resolve();
      return new Promise((res) => {
        img.onload  = res;
        img.onerror = res;  // resolve anyway so one broken image doesn't hang
      });
    })
  );
};
  // Fetch User Name by ID
  useEffect(() => {
    const fetchUserName = async () => {
      if (!transaction.userId) return;

      try {
        const userQuery = query(collection(db, "users"), where("cusmid", "==", transaction.userId));
        const querySnapshot = await getDocs(userQuery);

        if (!querySnapshot.empty) {
          const userData = querySnapshot.docs[0].data();
          setUserName(userData.name || "Unknown User");
        } else {
          console.warn("⚠️ User not found for ID:", transaction.userId);
        }
      } catch (error) {
        console.error("❌ Error fetching user:", error);
      }
    };

    fetchUserName();
  }, [transaction.userId]);

  // Fetch Store Details
  useEffect(() => {
    const fetchStoreDetails = async () => {
      try {
        const storeDocRef = doc(db, "settings", "contact"); // Replace "storeInfo" with your document ID
        const storeDoc = await getDoc(storeDocRef);

        if (storeDoc.exists()) {
          setStoreDetails(storeDoc.data());
        } else {
          console.warn("⚠️ Store details not found in Firestore.");
        }
      } catch (error) {
        console.error("❌ Error fetching store details:", error);
      }
    };

    fetchStoreDetails();
  }, []);

  useEffect(() => {
    const checkReceipt = async () => {
      try {
        const transactionQuery = query(
          collection(db, "transactions"),
          where("transactionId", "==", transaction.transactionId)
        );
        const querySnapshot = await getDocs(transactionQuery);

        if (!querySnapshot.empty) {
          const transactionDoc = querySnapshot.docs[0];
          // const receiptURL = transactionDoc.data().receiptURL;

          // if (receiptURL) {
          //   console.log("✅ Receipt already exists. Skipping upload.");
          //   setDownloadURL(receiptURL);
          //   setIsUploaded(true); // Mark as uploaded
          // } else {
          //   console.log("❌ No receipt found. Uploading...");
           
          // }
          captureAndUploadReceipt(transactionDoc.ref);
        }
      } catch (error) {
        console.error("❌ Error checking receipt:", error);
      }
    };

    checkReceipt();
  }, [transaction.transactionId, userName,transaction]);

  const captureAndUploadReceipt = async () => {
    if (!receiptRef.current || isUploaded || !userName) return;

    try {
      await ensureResourcesLoaded();
      const canvas = await html2canvas(receiptRef.current, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");
      setImgData(imgData);

      // Upload to Firebase Storage
      const storageRef = ref(storage, `receipts/Receipt_${transaction.transactionId}.png`);
      await uploadString(storageRef, imgData, "data_url");

      // Get the download URL
      const url = await getDownloadURL(storageRef);
      setDownloadURL(url);

      // Save receipt URL to Firestore
      const transactionQuery = query(
        collection(db, "transactions"),
        where("transactionId", "==", transaction.transactionId)
      );

      const querySnapshot = await getDocs(transactionQuery);

      if (!querySnapshot.empty) {
        const transactionDoc = querySnapshot.docs[0].ref; // Get the first matching document
        await updateDoc(transactionDoc, { receiptURL: url });
      } else {
        console.error("❌ Transaction not found!");
      }

      console.log("✅ Receipt uploaded successfully:", url);
    } catch (error) {
      console.error("❌ Error capturing and uploading receipt:", error);
    }
  };

  const downloadReceipt = () => {
    if (!imgData) return;

    // Create a hidden link to force download
    const link = document.createElement("a");
    link.href = imgData; // Ensure this URL ends with `?alt=media`
    link.setAttribute("download", `Receipt_${transaction.transactionId}.png`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="receipt-container">
      {/* Receipt Content */}
      <div
        className="receipt-content"
        ref={receiptRef}
        style={{
          width: "900px", // wider for landscape
          padding: "20px",
          border: "1.5px solid #000",
          borderRadius: "10px",
          backgroundColor: "#fff",
          margin: "0 auto",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          fontFamily: "Arial, sans-serif"
        }}
      >


        {/* Logo and Titles */}
       <Row
          className="mb-3 align-items-center"
          style={{
              background: 'linear-gradient(135deg, rgba(63, 121, 54, 1) 0%, rgba(30, 61, 26, 1) 100%)',
              padding: '10px',
              borderRadius: '8px'
          }}
        >
          <Col
            xs={5}
            className="d-flex justify-content-center align-items-center"
          >
            <img
              src="Asset.png"
              alt="PS Stores Logo"
              className="logo-c"

            />
          </Col>

          <Col
            xs={7}
            className="d-flex flex-column justify-content-center"
          >
            <h2 style={{ margin: 0, color: '#ffffff' }}>
              <b>PS Stores</b>
            </h2>
            <h5 style={{ margin: 0, color: '#ffffff' }}>
              Payment Receipt
            </h5>
          </Col>
        </Row>


        <hr />

        {/* Payment Information Table */}
        <Table bordered size="sm">
          <tbody>
           
            <tr>
              <td className="payment-data">
                <strong>Payment date</strong>
              </td>
              <td className="payment-data">
                {transaction.paymentDate
                  ?.toDate()
                  .toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false,
                  })}
              </td>
            </tr>
            <tr>
              <td className="payment-data"><strong>User Name</strong></td>
              <td className="payment-data">{userName || "Loading..."}</td>
            </tr>
            <tr>
              <td className="payment-data"><strong>Scheme</strong></td>
              <td className="payment-data">{transaction.schemename}</td>
            </tr>
            <tr>
              <td className="payment-data"><strong>Purchased Quantity</strong></td>
              <td className="payment-data">{transaction.Quantity}</td>
            </tr>
            <tr>
              <td className="payment-data"><strong>Months Paid</strong></td>
              <td className="payment-data">{transaction.totalpaid}/{transaction.overallmonths}<br/>{transaction?.paidFor}</td>
            </tr>
            <tr>
              <td className="payment-data"><strong>Transaction ID</strong></td>
              <td className="payment-data">{transaction.transactionId}</td>
            </tr>
            <tr>
              <td className="payment-data"><strong>Amount</strong></td>
              <td className="payment-data">₹{transaction.paymentAmount}</td>
            </tr>
            <tr>
              <td className="payment-data"><strong>Payment Type</strong></td>
              <td className="payment-data">{transaction.paymentType}</td>
            </tr>
              <tr>
              <td className="payment-data"><strong>Mode of payment</strong></td>
              <td className="payment-data">{transaction.ModeOfPayment}</td>
            </tr>
            <tr>
              <td className="payment-data"><strong>Payment Status</strong></td>
              <td className="payment-data">Success</td>
            </tr>
          </tbody>
        </Table>

        {/* Note */}
        <p style={{ fontSize: "12px", marginTop: "10px", color: "#555" }}>
          <strong>Note:</strong> Please keep this receipt and Transaction ID for your future communication. This is a computer generated receipt and signature is not required
        </p>
      </div>

      {/* Buttons */}
      <div className="text-center mt-3">
       
        <Button
          variant="success"
          className="btn-sm"
          style={{ marginTop: "10px" }}
          disabled={!downloadURL}
          onClick={downloadReceipt}
        >
          {downloadURL ? "Download Receipt" : "Receipt Generating"}
        </Button>
     
      </div>

    </div>
  );
};

export default GenerateReceipt;